<template>
  <div>
    <div class="d-block" v-if="reservation.isFirstBooking">
      <span class="first-table-badge">First Reservation</span>
    </div>
    <span class="role-table" v-if="reservation.stage === 'QUOTE'"> Quote </span>
    <router-link :to="goToEditReservation(reservation)">
      {{ reservation.booking_number }}

      <el-tooltip
        v-if="reservation.product"
        :content="
          reservationClass === 'Transfers'
            ? 'RhomTrip Experience'
            : 'Ventrata Experience'
        "
        placement="bottom"
      >
        <i
          class="flaticon-tools-traveling ml-1"
          :class="{
            'color-primary': reservationClass === 'Transfers',
            'text-danger': reservationClass != 'Transfers'
          }"
        >
        </i>
      </el-tooltip>
    </router-link>

    <el-popover
      placement="bottom"
      trigger="hover"
      width="300"
      class="curp d-inline-flex ml-1"
      v-if="reservation.childSeatsCount > 0 && reservationClass === 'Transfers'"
    >
      <div class="p-2">
        <span>
          <strong>Important: </strong>
          <span class="text-min hide-data-multiple">
            This reservation includes child seat(s). <br />
            <br />
            Please ensure that all requests have been confirmed with the
            supplier and correctly added as extras.
          </span>
        </span>
      </div>

      <div slot="reference" class="d-flex text-warning">
        <i class="flaticon-circle"></i>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: "ReservationBookingNumber",
  props: {
    reservation: {
      type: Object,
      required: true
    },
    reservationClass: {
      type: String,
      default: ""
    }
  },
  methods: {
    goToEditReservation(record) {
      if (record.class === "Transfers") {
        return record.stage === "QUOTE"
          ? `/reservations/quote/${record._id}`
          : `/reservations/${record._id}`;
      }
      return `/reservations/${record._id}?productId=${record.productId}`;
    }
  }
};
</script>
